/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

import type { PayloadAction } from "@reduxjs/toolkit";
import type {
  CardLinkedOffersState,
  CardLinkedOfferHistory,
  RewardOffer,
} from "./types";

const initialState: CardLinkedOffersState = {
  enrolled: false,
  offers: [],
  recommendedOffers: [],
  categories: [],
  offerHistory: {
    annualEarnings: 0 as Cents,
    redeemedOffers: [],
  },
};

type SetEnrolledAction = PayloadAction<boolean>;
type SetOffersAction = PayloadAction<{ offers: RewardOffer[] }>;
type SetCategoriesAction = PayloadAction<{ categories: string[] }>;
type SetAnnualEarningsAction = PayloadAction<{
  offerHistory: CardLinkedOfferHistory;
}>;
type SetSelectedCardIdAction = PayloadAction<{
  selectedCardId: API.CardId;
}>;

const cardLinkedOffersSlice = createSlice({
  name: "cardLinkedOffers",
  initialState,
  reducers: {
    setEnrolled: (state, { payload }: SetEnrolledAction) => {
      state.enrolled = payload;
    },
    setOffers: (state, { payload }: SetOffersAction) => {
      state.offers = payload.offers;
    },
    setRecommendedOffers: (state, { payload }: SetOffersAction) => {
      state.recommendedOffers = payload.offers;
    },
    setCategories: (state, { payload }: SetCategoriesAction) => {
      state.categories = payload.categories;
    },
    setOfferHistory: (state, { payload }: SetAnnualEarningsAction) => {
      state.offerHistory = payload.offerHistory;
    },
    setSelectedCardId: (state, { payload }: SetSelectedCardIdAction) => {
      state.selectedCardId = payload.selectedCardId;
    },
  },
});

export const { actions } = cardLinkedOffersSlice;

export default {
  cardLinkedOffers: cardLinkedOffersSlice.reducer,
};
